import { Component, Inject, Injectable, OnInit } from '@angular/core';
import { Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from "rxjs/BehaviorSubject";

import { Product } from '../models/product';
import { of } from 'rxjs/observable/of';


@Injectable()
export class ProductService {
  private h: HttpClient;
  private baseUrl: string;
  products: Product[];



  constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.h = http;
    this.baseUrl = baseUrl;
    }

    
  getProduct(productId: number): Product {
    this.products.forEach((p) => { // foreach statement  
      if (p.id == productId) {
        return p;
      }
    })
    return null;
  }

    getMyProducts(tenantId: string) {
        return this.h.get<Product[]>(this.baseUrl + 'api/Product/Products/' + tenantId).toPromise();
  }
  getProducts(tenantId : string) : Observable<Product[]> {
    this.h.get<Product[]>(this.baseUrl + 'api/Product/Products/' + tenantId).subscribe(result => {
      this.products = result;
        console.log("In getProducts of Service : ");
        console.log(result);
      return of(this.products)
    }, error => console.error(error));
    return of(null);
  }
  
}



// WEBPACK FOOTER //
// ./src/app/services/data.product.ts